export function removeAllNonContentElements(editor) {
  const editorBody = editor.getBody();
  const deletables = Array.from(editorBody.querySelectorAll('.Editor-non-content'));
  deletables.forEach(el => el.remove());
}